import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../../components/Logo";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Hoş geldiniz");
      navigate("/admin");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-charcoal grain flex items-center justify-center px-5">
      <div className="relative w-full max-w-md">
        <div className="flex items-center justify-center mb-8">
          <Logo to={null} height={48} />
        </div>
        <form onSubmit={submit} className="glass-dark rounded-3xl p-8 border border-white/10" data-testid="admin-login-form">
          <div className="flex items-center gap-2 text-white mb-6">
            <Lock className="w-4 h-4 text-gold" />
            <h1 className="font-display text-xl">Yönetici Girişi</h1>
          </div>
          {error && <div className="bg-red-500/15 text-red-300 text-sm rounded-lg px-4 py-2.5 mb-4" data-testid="login-error">{error}</div>}
          <label className="text-white/60 text-sm mb-2 block">E-posta</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
            className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-gold transition-colors mb-4" />
          <label className="text-white/60 text-sm mb-2 block">Şifre</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
            className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-gold transition-colors mb-6" />
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full rounded-full bg-gold text-charcoal font-semibold py-3.5 hover:bg-gold-soft transition-colors disabled:opacity-60">
            {loading ? "…" : "Giriş Yap"}
          </button>
        </form>
      </div>
    </div>
  );
}
